export const cookieConfig = {
    user: {
        name: 'usrz',
        days: 7
    }
};
